import React, { useState } from 'react';
import AuthField from './AuthField';
import Icon from '../../components/Icon';
import { Alert, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

export default function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sentMessage, setSentMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const data = await api.post('/api/auth/forgot-password', { email });
      setSentMessage(data?.message || 'If that email is registered, a reset link is on its way.');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (sentMessage) {
    return (
      <div className="auth-notice">
        <div className="auth-notice-icon">
          <Icon name="mail" size={26} />
        </div>
        <div className="auth-notice-title">Reset link sent</div>
        <p className="auth-notice-text">{sentMessage} Remember to check your spam folder.</p>
        <button type="button" className="btn btn-gradient btn-lg btn-block" onClick={onBack}>
          Back to sign in
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={submit} noValidate>
      <AuthField
        label="Email"
        icon="mail"
        type="email"
        value={email}
        onChange={setEmail}
        placeholder="you@example.com"
        autoComplete="email"
        required
      />
      {error && <Alert kind="error">{error}</Alert>}
      <button type="submit" className="btn btn-gradient btn-lg btn-block" disabled={busy}>
        {busy ? <Spinner label="Sending link" /> : 'Send reset link'}
      </button>
      <button type="button" className="link-btn" style={{ alignSelf: 'center' }} onClick={onBack}>
        Back to sign in
      </button>
    </form>
  );
}
